import { sendGet, sendPost } from './axios';

export const getConversation = () => sendGet(`/conversations?pageIndex=1&pageSize=100`);

export const sendMessage = (payload) => sendPost(`/chat/send-message`, payload);
export const getMessages = (payload) => sendGet(`/messages/${payload}`);
